import React, { useContext } from 'react';
import loadable from '@loadable/component';
import { Switch, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { AppContext } from 'contexts/AppContext';
import { UserContext } from 'contexts/UserContext';

import {
  HOUSEHOLD_STATUS_CANCELED,
  HOUSEHOLD_STATUS_DENIED,
} from 'utils/constants/household';

import useAsyncHouseholdMemberStatus from 'hooks/useAsyncHouseholdMemberStatus';
import { AsyncBox } from '@fortress-technology-solutions/fortress-component-library/Molecules';
import LayoutApp from 'components/Organisms/LayoutApp';
import AffordaPortal from 'pages/AffordaPortal';

/**
 * Variants
 */
const PortalResidential = loadable(() => import('pages/Portal/Residential'));
const PortalCommercial = loadable(() => import('pages/Portal/Commercial'));

const Portal = (props) => {
  const {
    match: { url },
  } = props;

  const {
    userProfile: { portalUserId, isCommercial },
  } = useContext(UserContext);
  const { isAffordableProperty } = useContext(AppContext);

  const { isLoading, status: memberStatus } = useAsyncHouseholdMemberStatus();

  const isCanceled = memberStatus === HOUSEHOLD_STATUS_CANCELED;
  const isDenied = memberStatus === HOUSEHOLD_STATUS_DENIED;
  const isCanceledOrDenied = isCanceled || isDenied;

  const { affordaPortaV1 } = useFlags();

  const showAffordaPortal = isAffordableProperty && affordaPortaV1;

  const isLoadingPage = !portalUserId || isLoading === true;
  return (
    <AsyncBox loading={isLoadingPage}>
      <Switch>
        {showAffordaPortal && <AffordaPortal url={url} />}
        <LayoutApp>
          {!isCommercial && (
            <PortalResidential
              url={url}
              isCanceled={isCanceled}
              isDenied={isDenied}
              isCanceledOrDenied={isCanceledOrDenied}
            />
          )}
          {isCommercial && (
            <PortalCommercial
              url={url}
              isCanceled={isCanceled}
              isDenied={isDenied}
              isCanceledOrDenied={isCanceledOrDenied}
            />
          )}
          <Redirect to={`${url}`} />
        </LayoutApp>
      </Switch>
    </AsyncBox>
  );
};

Portal.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
};

export default Portal;
